import { z } from 'zod';

export const FormSchema = z.object({
  ma_tt: z.string().optional(), // Payment term code can be empty
  ten_tt: z.string().optional(), // Payment term name can be empty
  ten_tt2: z.string().optional(), // Alternative name can be empty
  han_tt: z.union([z.number(), z.string()]).optional(), // Payment term days will be validated manually
  status: z.string().default('1') // Default status is '1'
});

export type FormSchemaType = z.infer<typeof FormSchema>;
export type PaymentTermSubmitData = FormSchemaType & { uuid?: string };

export const initialValues: FormSchemaType = {
  ma_tt: '',
  ten_tt: '',
  ten_tt2: '',
  han_tt: '',
  status: '1'
};
